import { createIosMenu } from '@zeego/menu'

const {
  Root,
  Trigger,
  Content,
  Item,
  ItemTitle,
  ItemSubtitle,
  TriggerItem,
  Group,
  Separator,
  ItemIcon,
  ItemImage,
  CheckboxItem,
  ItemIndicator,
  Label,
} = createIosMenu('DropdownMenu')

export {
  Root,
  Trigger,
  Content,
  Item,
  ItemTitle,
  ItemSubtitle,
  TriggerItem,
  Group,
  Separator,
  ItemIcon,
  ItemImage,
  CheckboxItem,
  ItemIndicator,
  Label,
}
